import { useMutation, useQueryClient } from "@tanstack/react-query";

import { listsQueryKeys } from "app/pages/sales-intelligence/modules/lists/query/key-factory/factory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

type Variables = { tagTitle: string; colorHex?: string };

export const useCreateTagMutation = (listId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ tagTitle, colorHex }: Variables) => {
            return salesApiService.listColumns.createTag(listId, tagTitle, colorHex);
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: listsQueryKeys.getTags(listId) });
        },
    });
};
